export default {
  "messageBox": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["消息盒子"])},
  "more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查看全部"])},
  "noMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["暂无消息"])},
  "list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["消息列表"])}
}